import { ref } from 'vue';

const serverAddress = ref(window.location.hostname === 'localhost' ? 'http://localhost:3127/api' : 'https://portal.montanacorporate.com/api');

export function useServerConfig() {
  return {
    serverAddress,
  };
}
